<template>
    <v-btn
        size="x-large"
        variant="flat"
        v-bind="$attrs"
        class="gst-button"
        :name="name"
        :type="type"
        :data-test-id="`button.${name}`"
        :loading="loading"
        :color="color">
        <template
            v-for="slotName in Object.keys($slots)"
            :slot="slotName">
            <slot :name="slotName"></slot>
        </template>
    </v-btn>
</template>

<script>
export default {
    name: 'BaseButton',
    props: {
        name: {
            type: String,
            default: null,
            required: true,
        },
        type: {
            type: String,
            default: 'button',
        },
        xLarge: {
            type: Boolean,
            default: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: 'primary',
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssVariables';
@import '@scssMixins';
.gst-button {
    transition: all 250ms ease-in-out 0s;
    font-weight: font-weight('medium');
    font-size: font-size('s');
    letter-spacing: normal;
    text-transform: none;
}
</style>
